
const digest = '51d0d63ec0a57346e9b002c83874b91ecf43a96316cdef45c5449bda2ecdddcc';
const classes = {"wrapper":"_wrapper_h3vi2_1"};
const css = `._wrapper_h3vi2_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  border-bottom: 1px solid #eaedf3;
  padding: 12px;
  gap: 30px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  